var _path, _rect, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmcyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.1H22C22.55 13.1 23 13.55 23 14.1V21C23 21.55 22.55 22 22 22H2C1.45 22 1 21.55 1 21V14.1C1 13.55 1.45 13.1 2 13.1Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.6,
    width: 4,
    height: 3.5,
    rx: 0.8,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.9C3 5.2 7 3 12 3C17 3 21 5.2 21 7.9V10H3V7.9Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 7.1C7.7 6 9.5 5.3 11.6 5.1",
    stroke: "#FFCDD2",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmcyButton);
export default __webpack_public_path__ + "static/media/emcy_button.6ecb7174f7d325a87c8271cd0ae0d310.svg";
export { ForwardRef as ReactComponent };